/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityModel } from '../../models/facility-model';

export interface FacilityClinicGroupIdIdGet$Params {
  clinicGroupId: string;
  id: string;
}

export function facilityClinicGroupIdIdGet(http: HttpClient, rootUrl: string, params: FacilityClinicGroupIdIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<FacilityModel>> {
  const rb = new RequestBuilder(rootUrl, facilityClinicGroupIdIdGet.PATH, 'get');
  if (params) {
    rb.path('clinicGroupId', params.clinicGroupId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<FacilityModel>;
    })
  );
}

facilityClinicGroupIdIdGet.PATH = '/Facility/{clinicGroupId}/{id}';
